import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import { navigateToDefaultPage } from "../../services/navigateService";
import Layout from "../Layout";
import { useEffect } from "react";

const RootPage = () => {

  const navigate = useNavigate()

  useEffect(() => {
    navigateToDefaultPage(navigate)
  })

  return (
    <>
      <Layout />
    </>
  );
};

export default RootPage;